import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation DeleteAgentConfiguration(
    $tenantId: ID!
    $zoneId: ID!
    $agentId: String!
    $conversationId: String
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        deleteAgentConfiguration(
          agentId: $agentId
          conversationId: $conversationId
        )
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.select<
  graphql.schema.DeleteAgentConfigurationMutation,
  undefined,
  'tenant'
>(
  'tenant',
  graphql.transformers.OUT.select(
    'zone',
    graphql.transformers.OUT.select(
      'deleteAgentConfiguration',
      graphql.transformers.OUT.always(undefined),
    ),
  ),
)

export const executor = graphql.createExecutor<
  graphql.schema.DeleteAgentConfigurationMutation,
  undefined,
  graphql.schema.DeleteAgentConfigurationMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
